import z from "zod";

export const GetInternalCacheResponseSchema = z.record(z.string(), z.any());
export type GetInternalCacheResponse = z.infer<typeof GetInternalCacheResponseSchema>;
